import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  pure: false
})
export class FilterPipe implements PipeTransform {

  transform(value: any, args:any[] ): any {
    let filter = args[0];
    var counter = args[1];
    if (filter && Array.isArray(value)) {
        let filterKeys = Object.keys(filter);
        var items = value.filter(item =>
          filterKeys.reduce((memo, keyName) =>
            memo && item[keyName] === filter[keyName], true));
        if (counter) {
          counter.count = items.length;
        }
        return items;
    }
    else {
      if (counter) {
        counter.count = 0;
      }
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/global/multi-select-dropdown/filter.pipe.ts